import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Checkbox } from 'antd';
import {
    Box,
    Typography,
    Grid,
    Button,
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Stack,
    FormGroup,
} from '@mui/material';
import classNames from 'classnames/bind';
import TitleUser from '~/components/TitleUser';
import images from '~/assets/images';
import styles from './AddCourseVideo.module.scss';
import AddVideo from '~/components/AddVideo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faChevronLeft, faClose } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { edit_course_video, add_course_video, add_chapter } from '~/Store/Action/courseActions';
// import { edit_course_online } from '~/Store/Action/courseActions';
import { detailCourseOnline, checkBuyCourse } from '~/Store/Action/detailCourseActions';
import { useNavigate } from 'react-router-dom';
import { category } from '~/Store/Action/categoryActions';
import SunEditor from 'suneditor-react';
import { useParams } from 'react-router-dom';

const cx = classNames.bind(styles);

const AddCourseVideo = () => {
    const { id } = useParams();
    const [visible, setVisible] = useState(false);

    const [addVideoState, setAddVideoState] = useState({
        visible: false,
    });

    const navigate = useNavigate();

    const [chapters, setChapters] = useState([]);

    const [img, setImg] = useState(null);

    const dispatch = useDispatch();
    const list = useSelector((state) => state.category.list);
    // const listCourseVideo = useSelector((state) => state.course.listCourseVideo);
    const auth = useSelector((state) => state.auth);
    const data = useSelector((state) => state.detailCourse?.data?.data);

    useEffect(() => {
        async function load() {
            await dispatch(category());
            await dispatch(detailCourseOnline(id));
        }
        load();
    }, []);

    const onAdd = async () => {
        const data = await onAddCourse();
        console.log(data);

        const id = await data.data.data.id;
        // await console.log(id);

        // const formDataArray = chapters.map((item) => {
        //     const formData = new FormData();
        //     formData.append('title', item.title);
        //     formData.append('status', item.status);
        //     formData.append('description', item.link);

        //     if (item.image) {
        //         formData.append('file', item.image);
        //     }

        //     return formData;
        // });

        // console.log('123');
        // const form = formDataArray.map((form) => {
        //     for (const [key, value] of form) {
        //         console.log(`${key}:`, value);
        //     }
        //     dispatch(add_chapter(auth.token, form, id));
        // });

        // Gửi
        // if (await dispatch(edit_course_online(auth.token, formData, id))) {
        navigate('/tai-khoan/quan-ly-khoa-hoc-video');
        // }
        // dispatch(show_alert());
    };

    const onAddCourse = async () => {
        // event.preventDefault();
        var form_question = document.getElementById('form_data');
        var formData = new FormData(form_question);

        // xem trong form có những gì
        for (const [key, value] of formData) {
            console.log(`${key}:`, value);
        }

        const data = await dispatch(edit_course_video(auth.token, formData, id));
        return data;
        // if (await dispatch(add_course_online(auth.token, formData))) {
        //     navigate(`/tai-khoan/quan-ly-khoa-hoc-online`);
        // }
    };

    const addChapters = async () => {
        const data = await {
            title: chapter.title,
            link: chapter.link,
            image: chapter.image,
            path: null,
            status: chapter.status,
        };
        await setChapters([...chapters, data]);
        await console.log(chapters);
        await handleCancel();
    };

    const onLog = async () => {
        await console.log(chapters);
    };

    const [chapter, setChapter] = useState({ title: '', link: '', image: null, path: null, status: 0 });

    const handleChapterTitleChange = (event) => {
        const newChapter = chapter;
        newChapter.title = event.target.value;
        setChapter(newChapter);
    };

    const handleChapterLinkChange = (event) => {
        const newChapter = chapter;
        newChapter.link = event.target.value;
        setChapter(newChapter);
    };

    const handleChapterImageChange = (event) => {
        const newChapter = chapter;
        const files = event.target.files;
        console.log(files);
        newChapter.image = files[0];

        const imageArray = Array.from(files).map((file) => URL.createObjectURL(file));
        newChapter.path = imageArray;
        console.log(event.target);
        setChapter(newChapter);
    };

    const handleChapterStatusChange = (event) => {
        const newChapter = chapter;
        newChapter.status = event.target.value;
        setChapter(newChapter);
    };

    const handleOpenAddVideo = (defaultKey) => {
        setVisible(true);
        setAddVideoState({ ...addVideoState, visible: true, defaultKey });
    };

    const handleCancel = () => {
        setVisible(false);
    };

    const handleImg = (event) => {
        const files = event.target.files;
        const image = Array.from(files).map((file) => URL.createObjectURL(file));
        setImg(image);
    };

    return (
        <Box className={cx('AddCourseVideo', 'container')}>
            <Box py="10px" className={cx('Breadcumb')}>
                <Typography sx={{ paddingRight: '10px' }} className={cx('title')}>
                    <Link to="/">Trang chủ</Link>
                </Typography>
                ›
                <Typography sx={{ paddingLeft: '10px', paddingRight: '10px' }} className={cx('title')}>
                    <Link to="/tai-khoan/quan-ly-khoa-hoc-video">Tài khoản</Link>
                </Typography>
                ›
                <Typography sx={{ paddingLeft: '10px', paddingRight: '10px' }} className={cx('title')}>
                    <Link to="/tai-khoan/quan-ly-khoa-hoc-video">Quản lý chuyên gia đối tác</Link>
                </Typography>
                ›
                <Typography sx={{ paddingLeft: '10px', paddingRight: '10px' }} className={cx('title')}>
                    <Link to="/tai-khoan/quan-ly-khoa-hoc-video">Quản lý khóa học video</Link>
                </Typography>
                ›
                <Typography sx={{ paddingLeft: '10px', paddingRight: '10px' }} className={cx('title')}>
                    <Link to="#">Sửa khóa học video</Link>
                </Typography>
            </Box>
            {data && (
                <>
                    <form id="form_data" method="post" enctype="multipart/form-data">
                        <Grid
                            container
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                            sx={{ flexGrow: 1 }}
                            className={cx('wrapper')}
                        >
                            <Grid pb={2} pr={2} xs={6}>
                                <TitleUser className={cx('title-wp')} title="Sửa khóa học video" />
                                <Box
                                    className={cx('content-wp') + ' wpp'}
                                    style={{
                                        backgroundImage: `url(${img ?? data?.image})`,
                                        backgroundRepeat: 'no-repeat',
                                        backgroundSize: 'cover',
                                    }}
                                >
                                    <label className={cx('content')} htmlFor="upload-img-btn">
                                        <TextField
                                            label="Chọn ảnh"
                                            type="file"
                                            accept="image/*"
                                            name="image"
                                            onChange={(event) => handleImg(event)}
                                            style={{ display: 'none' }}
                                            id="upload-img-btn"
                                        />
                                        <Box className={cx('wp-file')}>
                                            <img src={images.camera} alt="chọn ảnh" />
                                        </Box>
                                    </label>
                                    <Typography sx={{ fontSize: '16px', padding: '10px 0px' }}>
                                        Tải ảnh lên (4 x 2)
                                    </Typography>
                                </Box>

                                <FormControl sx={{ paddingTop: '10px' }} fullWidth>
                                    <Stack spacing={2}>
                                        <input name="course_type_id" value="2" type="hidden" />
                                        <TextField
                                            label="Tiêu đề"
                                            variant="outlined"
                                            name="title"
                                            defaultValue={data?.title}
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    fontSize: '16px',
                                                    background: '#fff',
                                                    fontWeight: 'bold',
                                                    padding: '11.5px 14px',
                                                },
                                                '& .MuiInputLabel-root': {
                                                    color: '#333',
                                                    fontWeight: 'bold',
                                                    fontSize: '16px',
                                                    top: '-10%',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        fontSize: '16px',
                                                    },
                                                },
                                            }}
                                        />
                                        <FormControl fullWidth>
                                            <InputLabel
                                                sx={{ fontSize: '16px', color: '#333', fontWeight: 'bold' }}
                                                id="demo-simple-select-label"
                                            >
                                                Chọn danh mục
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="course_category_id"
                                                defaultValue={data?.category?.id}
                                                label="Chọn danh mục"
                                                sx={{
                                                    '& .MuiSelect-root': {
                                                        color: 'blue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '16px',
                                                        padding: '14px',
                                                        background: '#fff',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        color: '#333',
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                        top: '-3%',
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        //   borderColor: 'orange',
                                                    },
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        span: {
                                                            fontSize: '12px',
                                                        },
                                                    },
                                                }}
                                            >
                                                {list?.data?.course_categories.map((item, index) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <TextField
                                            label="Tiền (vnđ)"
                                            variant="outlined"
                                            name="price"
                                            defaultValue={data?.price}
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    fontSize: '16px',
                                                    background: '#fff',
                                                    fontWeight: 'bold',
                                                    padding: '11.5px 14px',
                                                },
                                                '& .MuiInputLabel-root': {
                                                    color: '#333',
                                                    fontWeight: 'bold',
                                                    fontSize: '16px',
                                                    top: '-10%',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        fontSize: '16px',
                                                    },
                                                },
                                            }}
                                        />
                                        <TextField
                                            label="Tiền sau giảm giá (vnđ)"
                                            variant="outlined"
                                            name="discount_price"
                                            defaultValue={data?.discount_price}
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    fontSize: '16px',
                                                    background: '#fff',
                                                    fontWeight: 'bold',
                                                    padding: '11.5px 14px',
                                                },
                                                '& .MuiInputLabel-root': {
                                                    color: '#333',
                                                    fontWeight: 'bold',
                                                    fontSize: '16px',
                                                    top: '-10%',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        fontSize: '16px',
                                                    },
                                                },
                                            }}
                                        />
                                        <TextField
                                            label="Tiền xu"
                                            variant="outlined"
                                            name="coin_price"
                                            defaultValue={data?.coin_price}
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    fontSize: '16px',
                                                    background: '#fff',
                                                    fontWeight: 'bold',
                                                    padding: '11.5px 14px',
                                                },
                                                '& .MuiInputLabel-root': {
                                                    color: '#333',
                                                    fontWeight: 'bold',
                                                    fontSize: '16px',
                                                    top: '-10%',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        fontSize: '16px',
                                                    },
                                                },
                                            }}
                                        />
                                        <TextField
                                            label="Tiền sau giảm giá xu (xu)"
                                            variant="outlined"
                                            name="discount_coin_price"
                                            defaultValue={data?.discount_coin_price}
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    fontSize: '16px',
                                                    background: '#fff',
                                                    fontWeight: 'bold',
                                                    padding: '11.5px 14px',
                                                },
                                                '& .MuiInputLabel-root': {
                                                    color: '#333',
                                                    fontWeight: 'bold',
                                                    fontSize: '16px',
                                                    top: '-10%',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        fontSize: '16px',
                                                    },
                                                },
                                            }}
                                        />
                                        <FormControl fullWidth>
                                            <InputLabel
                                                sx={{ fontSize: '16px', color: '#333', fontWeight: 'bold' }}
                                                id="demo-simple-select-label"
                                            >
                                                Chọn chuyên nghành
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                // value={age}
                                                name="specialization_id"
                                                defaultValue={data?.specialization?.id}
                                                label="Chọn chuyên nghành"
                                                // onChange={handleChange}
                                                sx={{
                                                    '& .MuiSelect-root': {
                                                        color: 'blue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '16px',
                                                        padding: '14px',
                                                        display: 'flex',
                                                        alignContent: 'center',
                                                        background: '#fff',
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        color: '#333',
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                        top: '-3%',
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        //   borderColor: 'orange',
                                                    },
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        span: {
                                                            fontSize: '12px',
                                                        },
                                                    },
                                                }}
                                            >
                                                {list?.data?.specializations.map((item, index) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        <SunEditor
                                            name="description"
                                            defaultValue={data?.description}
                                            height="500"
                                            setOptions={{
                                                buttonList: [
                                                    ['undo', 'redo'],
                                                    ['font', 'fontSize', 'formatBlock'],
                                                    // ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                                    ['bold', 'underline', 'italic', 'strike'],
                                                    ['removeFormat'],
                                                    ['outdent', 'indent'],
                                                    ['align', 'horizontalRule', 'list', 'table'],
                                                    ['fontColor', 'hiliteColor'],
                                                    ['link', 'image'],
                                                    ['fullScreen', 'showBlocks', 'codeView'],
                                                    // ['preview', 'print'],
                                                ],
                                            }}
                                        />
                                    </Stack>
                                </FormControl>
                            </Grid>
                            {/* <Grid pt={6} pr={2} xs={6}>
                                <div className={cx('list-chapper')}>
                                    <TitleUser className={cx('title-wp')} title="Danh sách chương" />
                                    <div className={cx('check')}>
                                        <span style={{ paddingRight: '10px' }}>Chọn tất cả</span>
                                        <Checkbox />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    {chapters.map((item, index) => (
                                        <div
                                            className="col-12 col-sm-12 col-lg-12 mb-4 wow animate__animated animate__backInRight"
                                            key={index}
                                        >
                                            <Link className="card" to="">
                                                <div className="card-body">
                                                    <h2
                                                        className="text-dark"
                                                        style={{
                                                            fontSize: '16px',
                                                            fontFamily: 'sans-serif',
                                                            marginBottom: 0,
                                                        }}
                                                    >
                                                        <Checkbox />
                                                        <span style={{ paddingLeft: '10px' }}>{item.title}</span>
                                                    </h2>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            padding: '10px 0px',
                                                        }}
                                                    >
                                                        <span style={{ color: 'rgba(119, 119, 119, 1)' }} className="p">
                                                            Video tải lên
                                                        </span>
                                                        <span className="p" style={{ color: 'rgba(39, 171, 96, 1)' }}>
                                                            {item.status == 0 ? 'Mở' : 'khoá'}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex">
                                                        <span className="p">08:00- 20/12/2022</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                                <Button className={cx('add_video')} onClick={handleOpenAddVideo}>
                                    Thêm video
                                </Button>
                            </Grid> */}
                            <div style={{ width: '100%', textAlign: 'center' }}>
                                <Button className={cx('btn_submit')} variant="contained" onClick={onAdd}>
                                    Xác nhận sửa
                                </Button>

                                {/* <Button className={cx('btn_submit')} variant="contained" onClick={onLog}>
                            Log
                        </Button> */}
                            </div>
                        </Grid>
                    </form>

                    <AddVideo addVideoState={addVideoState} visible={visible} handleCancel={handleCancel}>
                        <div className={cx('header-modal-back')}>
                            <h4>Thêm mới video</h4>
                            <FontAwesomeIcon className={cx('close')} icon={faClose} />
                        </div>
                        <FormGroup sx={{ padding: '18px', height: '600px' }}>
                            <Stack spacing={2}>
                                <TextField
                                    className={cx('input-change')}
                                    fullWidth
                                    id="title"
                                    label="Tiêu đề"
                                    onChange={(event) => handleChapterTitleChange(event)}
                                    variant="outlined"
                                    sx={{
                                        '& .MuiInputBase-input': {
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            padding: '11.5px 14px',
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontWeight: 'bold',
                                            fontSize: '16px',
                                            top: '-10%',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '40px',

                                            '& fieldset': {
                                                fontSize: '16px',
                                            },
                                        },
                                    }}
                                />
                                <select
                                    style={{ padding: '13px', borderRadius: '40px' }}
                                    onChange={(event) => handleChapterStatusChange(event)}
                                >
                                    <option value="0">Mở</option>
                                    <option value="1">Không mở</option>
                                </select>
                                <TextField
                                    className={cx('input-change')}
                                    fullWidth
                                    type="text"
                                    id="link-video"
                                    label="Link video"
                                    onChange={(event) => handleChapterLinkChange(event)}
                                    variant="outlined"
                                    sx={{
                                        '& .MuiInputBase-input': {
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            padding: '11.5px 14px',
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontWeight: 'bold',
                                            fontSize: '16px',
                                            top: '-10%',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '40px',
                                            '& fieldset': {
                                                fontSize: '16px',
                                            },
                                        },
                                    }}
                                />
                                <div>Hoặc tải video lên</div>
                                <TextField
                                    label="Chọn ảnh"
                                    type="file"
                                    accept="image/*"
                                    onChange={(event) => handleChapterImageChange(event)}
                                    style={{ display: 'none' }}
                                    id="upload-img-btn1"
                                />
                                <label className={cx('file-upload')} htmlFor="upload-img-btn1">
                                    <span>File đính kèm</span>
                                    <div className={cx('upload')}>
                                        <img src={images.Upload} alt="upload file" />
                                    </div>
                                </label>
                            </Stack>
                        </FormGroup>
                        <div style={{ textAlign: 'center', padding: '10px' }}>
                            <Button
                                sx={{ width: '90%', padding: '10px', marginBottom: '20px' }}
                                onClick={addChapters}
                                className={cx('btn_yes')}
                                variant="contained"
                            >
                                ĐỒNG Ý
                            </Button>
                        </div>
                    </AddVideo>
                </>
            )}
        </Box>
    );
};

export default AddCourseVideo;
